import WideoAsset from "./WideoAsset";

export default class WideoAssetImage extends WideoAsset {
    public getAssetType = () => {
        return "wideoImages";
    }    
}


// WEBPACK FOOTER //
// src/opt/atlassian/pipelines/agent/build/src/api/model/WideoAssetImage.ts